import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { verifyStatus } from "../../../actions/userActions";
import RejectButtonFi from "./RejectButtonFi";
import { withRouter } from "react-router-dom";
import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { Alert } from "bootstrap";
import * as myConctList from "../../pages/baseUrl";

const baseUrl = myConctList.baseUrl;
class VerifyDocument1 extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      records: [],
      id: "",
      i_image: "",
      identity_status: "",
      reject: "",
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    {
      console.log("propsprops", nextProps.record);
    }
    if (nextProps.record) {
    
        this.setState({
          email: nextProps.record.email,
          mobilenumber: nextProps.record.mobilenumber,
        
        });
      
      
      
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (nextProps.userrecords) {
      this.setState({
        tstatus: nextProps.userrecords.status,
      });
    }
  }
  getNodesToRemoveFromElement = (stringContent) => {
    var div = document.createElement("div");
    div.innerHTML = stringContent;
    var text = div.textContent || div.innerText || "";
    return text;
  };

  handleCommentChange = (event, editor) => {
    var data = editor.getData();
    if (data) {
      this.setState({ description: data });
    }
    this.setState({
      showResults: this.state.name === null ? false : true,
    });
  };

  onUpdate = (e) => {
    e.preventDefault();

    const newUser = {
      _id: this.props.match.params.id,
      type: "d1",
    };
    this.props.verifyStatus(newUser);
  };
  onChange = (e) => {
    if (e.target.id === "reject") {
      this.setState({ reject: e.target.value });
    }
  };

  render() {
    const { errors } = this.state;
    const { user } = this.state;
    return (
      <>
        {this.state.identity_status !== undefined && (
          <>
            <div className="in_page">
                <div className="user-personal">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="user-detail-inner-main d-flex align-items-center">
                        <h5 htmlFor="BankName">Email : </h5>
                        <p>{this.state.email}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="user-detail-inner-main d-flex align-items-center">
                        <h5 htmlFor="BranchName">Mobile Number :</h5>
                        <p>{this.state.mobilenumber}</p>
                      </div>
                    </div>
                   
                  
                  </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

VerifyDocument1.propTypes = {
  verifyStatus: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { verifyStatus })(
  withRouter(VerifyDocument1)
);
